import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
// eslint-disable-next-line @nx/enforce-module-boundaries
import { ComponentNameTranslationPipe, LevelNameTranslationPipe } from '@twaice-fe/frontend/shared/services';
import { StorageLevel } from '@twaice-fe/shared/models';
import { NzCardComponent } from 'ng-zorro-antd/card';

@Component({
  selector: 'twaice-fe-non-operating-string-recommendation',
  templateUrl: './non-operating-string-recommendation.component.html',
  imports: [CommonModule, NzCardComponent, ComponentNameTranslationPipe, LevelNameTranslationPipe],
  styleUrl: './non-operating-string-recommendation.component.scss',
})
export class NonOperatingStringRecommendationComponent {
  @Input() componentBk: string | undefined;
  @Input() enclosureBk: string | null;

  protected readonly storageLevel = StorageLevel;
}
